import { ROUTE_PERMISSION_MAP, P, getFirstPermittedPath } from "@/constants/permissions";
import { usePermissions, useUserToken } from "@/store/userStore";
import { useCallback, useEffect } from "react";
import { useLocation } from "react-router";
import { useRouter } from "../hooks";

type Props = {
	children: React.ReactNode;
};
export default function AuthGuard({ children }: Props) {
	const router = useRouter();
	const { token } = useUserToken();
	const permissions = usePermissions();
	const location = useLocation();

	const check = useCallback(() => {
		if (!token) {
			router.replace("/auth/login");
			return;
		}

		// Permissions not yet loaded — wait, don't redirect
		if (permissions === null) return;
		const perms = permissions;

		const currentPath = location.pathname;
		const requiredPermission = ROUTE_PERMISSION_MAP[currentPath];

		if (requiredPermission === undefined) return;

		if (requiredPermission === "") {
			if (currentPath === "/pw_management/wallets") {
				if (!perms.includes(P.CRYPTO_WALLET_READ) && !perms.includes(P.FIAT_WALLET_READ)) {
					router.replace(getFirstPermittedPath(perms));
				}
			}
			return;
		}

		if (!perms.includes(requiredPermission)) {
			router.replace(getFirstPermittedPath(perms));
		}
	}, [router, token, permissions, location.pathname]);

	useEffect(() => {
		check();
	}, [check]);

	return <>{children}</>;
}
